export default __webpack_public_path__ + "static/man-with-puzzle-and-icons-66d54d2b24f1c07411f1bd43c516619c.svg";